import { useCallback, useEffect, useState } from "react";
import Loader from "../../components/Loader";
import { Link, useNavigate } from "react-router-dom";
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid2,
  Radio,
  RadioGroup,
} from "@mui/material";
import StyledGridComp from "../../components/StyledGridComp";
import SearchedComponent from "../../components/SearchedComponent";
import {
  fetchAllMaterialDataService,
  submitMaterialListService,
} from "../../services/materialListApprovalService";
import { notifyError, notifySuccess } from "../../utilities/helper";
import useDebounceSearch from "../../hooks/useDebounceSearch";
import { Home } from "@mui/icons-material";

const MaterialListApproval = () => {
  const [load, setLoad] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(15);
  const [rowData, setRowData] = useState([]);
  const [rowLength, setRowLength] = useState(0);
  const [searchedValue, setSearchedValue] = useState("");
  const [radioValue, setRadioValue] = useState("");
  const navigate = useNavigate();

  const access_token = localStorage?.getItem("access_token");
  const roleId = localStorage.getItem("roleId");
  const email = localStorage.getItem("email");

  const debounceQuery = useDebounceSearch(searchedValue, 500);

  useEffect(() => {
    if (page >= 0 && pageSize && access_token) {
      fetchAllMaterialListData(page, pageSize, access_token, debounceQuery);
    }
  }, [pageSize, page, debounceQuery]);

  const columns = [
    {
      field: "drugKitNumber",
      headerName: "Drug Kit Number",
      width: 325,
      renderHeader: () => (
        <div className="grid-heading">{"Drug Kit Number"}</div>
      ),
      renderCell: (params) => {
        const drugKitNumber = params.row.drugKitNumber;

        return <span>{drugKitNumber}</span>;
      },
    },
    {
      field: "sequenceNumber",
      headerName: "Sequence Number",
      width: 325,
      renderHeader: () => (
        <div className="grid-heading">{"Sequence Number"}</div>
      ),
      renderCell: (params) => {
        const sequenceNumber = params.row.sequenceNumber;

        return <span>{sequenceNumber}</span>;
      },
    },
    {
      field: "drugType",
      headerName: "Drug Type",
      width: 325,
      renderHeader: () => <div className="grid-heading">{"Drug Type"}</div>,
      renderCell: (params) => {
        const drugType = params.row.drugTypeName;

        return <span>{drugType}</span>;
      },
    },
    {
      field: "packageType",
      headerName: "Package Type",
      width: 325,
      renderHeader: () => <div className="grid-heading">{"Package Type"}</div>,
      renderCell: (params) => {
        const packageType = params.row.packageName;

        return <span>{packageType}</span>;
      },
    },
  ];

  const fetchAllMaterialListData = async (
    page,
    pageSize,
    access_Token,
    debouncedSearch = "",
  ) => {
    setLoad(true);
    try {
      const res = await fetchAllMaterialDataService(
        page + 1,
        pageSize,
        access_Token,
        debouncedSearch,
      );
      if (res?.status === 200) {
        setRowData(res?.data?.result);
        setRowLength(res?.data?.totalCount);
        setLoad(false);
      } else if (res?.status == 401) {
        navigate("/unauthorize");
      }
    } catch (err) {
      setLoad(false);
      if (err?.status == 401) {
        navigate("/unauthorize");
      }
    }
  };

  const handleSearch = useCallback((e) => {
    setSearchedValue(e.target.value);
  }, []);

  const submitMaterialList = async (e) => {
    e.preventDefault();
    try {
      setLoad(true);
      const data = {
        userId: roleId,
        userName: email,
        isApproved: radioValue === "approve" ? true : false,
      };
      const res = await submitMaterialListService(access_token, data);
      if (res?.data?.status == 200) {
        notifySuccess(res?.data?.message);
        setLoad(false);
        fetchAllMaterialListData(page, pageSize, access_token, debounceQuery);
      } else if (res?.data?.status == 409) {
        notifySuccess(res?.data?.message);
        setLoad(false);
        fetchAllMaterialListData(page, pageSize, access_token, debounceQuery);
      }
    } catch (err) {
      setLoad(false);
      notifyError(err?.response?.data?.message);
      if (err?.response?.status == 401) {
        navigate("/unauthorize");
      }
      console.log("Error in Submit Material List", err);
    }
  };

  return (
    <div className="content-body">
      <div className="home-container">
        <p
          className="bread-crumbs-link-container"
          style={{ fontWeight: "600" }}
        >
          <Link className="bread-crumbs-link" to="/">
            Home
          </Link>{" "}
          |{" "}
          <Link className="bread-crumbs-link" to="/material-list-approval">
            Material List Approval
          </Link>
          -{" "}
          <b style={{ color: "gray" }}>{localStorage?.getItem("studyName")}</b>
        </p>
        <Link className="bread-crumbs-link home-inner-container">
          Set as Home Page
          <span>
            <Home
              sx={{
                fontSize: "20px",
              }}
            />
          </span>
        </Link>
      </div>
      <Grid2
        container
        alignItems="center"
        justifyContent="space-between"
        sx={{ width: "100%", margin: "0 auto" }}
      >
        <Grid2 item md={6}>
          <p className="page-heading">Material List Approval</p>
        </Grid2>
        <Grid2 item md={6}>
          <div className="search-bar-container">
            <SearchedComponent
              handleSearch={handleSearch}
              placeholder="Kits"
              searchedValue={searchedValue}
            />
          </div>
        </Grid2>
      </Grid2>

      {load ? (
        <Loader />
      ) : (
        <>
          <StyledGridComp
            rows={rowData}
            columns={columns}
            page={page}
            setPage={setPage}
            pageSize={pageSize}
            setPageSize={setPageSize}
            length={rowLength}
          ></StyledGridComp>
          <div
            style={{
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
              marginTop: "2%",
            }}
          >
            <FormControl>
              <FormLabel id="demo-radio-buttons-group-label">
                Is this material list approved for release ?
              </FormLabel>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                name="radio-buttons-group"
              >
                <FormControlLabel
                  value="approve"
                  onChange={(e) => {
                    setRadioValue(e.target.value);
                  }}
                  control={<Radio />}
                  label="Approve"
                />
                <FormControlLabel
                  onChange={(e) => {
                    setRadioValue(e.target.value);
                  }}
                  value="notApprove"
                  control={<Radio />}
                  label="Not Approve"
                />
              </RadioGroup>
            </FormControl>
          </div>
        </>
      )}

      <Grid2
        alignItems={"end"}
        justifyContent="end"
        container
        gap={3}
        sx={{ marginTop: "2%" }}
      >
        <Grid2 item md={6}>
          <button
            type="button"
            className="create-btn-outlined"
            onClick={(e) => {}}
          >
            Back
          </button>
        </Grid2>
        <Grid2 item md={6}>
          <button
            onClick={(e) => {
              submitMaterialList(e);
            }}
            disabled={radioValue === "" || rowData?.length == 0 ? true : false}
            className={
              radioValue === "" || rowData?.length == 0
                ? "disabled-btn"
                : "create-btn"
            }
          >
            Save
          </button>
        </Grid2>
      </Grid2>
    </div>
  );
};

export default MaterialListApproval;
